<template>
  <div class="image-preview" id="image-preview" v-if="visible">
    <img
      id="imagepreview"
      crossOrigin="anonymous"
      class="d-none"
      :src="`${currentUrl}?time=${date}`"
    />

    <div class="viewer-container">
      <template v-if="hasAlbum">
        <template v-if="current.type === 'video'">
          <video
            :src="current.url"
            style="max-width: 100%; max-height: 100%; background: #000"
            controls
            autoplay
            playsinline
          />
        </template>
        <template v-else>
          <img :src="current.url" alt="" class="album-image" />
        </template>
      </template>
      <template v-else>
        <img :src="image" alt="" class="album-image" />
      </template>
    </div>

    <div class="image-preview__action-layer">
      <div
        class="image-preview__close image-preview__cir-action"
        id="image-preview__close"
        @click="$emit('close')"
      >
        <feather-icon icon="XIcon" size="22" />
      </div>
      <div
        v-if="hasPrev"
        class="image-preview_prev image-preview__cir-action"
        @click="prev"
      >
        <feather-icon icon="ChevronLeftIcon" size="22" />
      </div>
      <div
        v-if="hasNext"
        class="image-preview_next image-preview__cir-action"
        @click="next"
      >
        <feather-icon icon="ChevronRightIcon" size="22" />
      </div>
      <div
        class="image-preview__download action-btn image-preview__cir-action"
        @click="download"
      >
        <feather-icon icon="ArrowDownCircleIcon" size="22" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      image: {
        type: String,
        default: ''
      },
      album: {
        type: Array,
        default: () => []
      },
      albumIndex: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        date: '',
        idx: 0
      };
    },
    computed: {
      hasAlbum() {
        return Array.isArray(this.album) && this.album.length > 0;
      },
      visible() {
        return !!this.image;
      },
      current() {
        if (!this.hasAlbum) return { url: this.image, type: 'image' };
        return this.album[this.idx] || { url: this.image, type: 'image' };
      },
      currentUrl() {
        return this.current?.url || this.image;
      },
      hasPrev() {
        return this.hasAlbum && this.idx > 0;
      },
      hasNext() {
        return this.hasAlbum && this.idx < this.album.length - 1;
      }
    },
    watch: {
      image(newVal) {
        if (String(newVal || '').trim()) {
          this.idx = this.albumIndex || 0;
        }
      }
    },
    mounted() {
      document.addEventListener('keydown', this.handleKeydown);
    },
    beforeDestroy() {
      document.removeEventListener('keydown', this.handleKeydown);
    },
    methods: {
      handleKeydown(event) {
        if (!this.visible) return;

        switch (event.key) {
          case 'ArrowLeft':
            event.preventDefault();
            this.prev();
            break;
          case 'ArrowRight':
            event.preventDefault();
            this.next();
            break;
        }
      },
      next() {
        if (!this.hasAlbum) return;
        if (this.idx < this.album.length - 1) this.idx += 1;
      },
      prev() {
        if (!this.hasAlbum) return;
        if (this.idx > 0) this.idx -= 1;
      },
      getBase64ImageUrl(img) {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL('image/png');
        return dataURL;
      },
      base64ToBlob(code) {
        let parts = code.split(';base64,');
        let contentType = parts[0].split(':')[1];
        let raw = window.atob(parts[1]);
        let rawLength = raw.length;
        let uInt8Array = new Uint8Array(rawLength);
        for (let i = 0; i < rawLength; ++i) {
          uInt8Array[i] = raw.charCodeAt(i);
        }
        return new Blob([uInt8Array], {
          type: contentType
        });
      },
      download() {
        this.date = new Date().getMilliseconds();
        var url = this.getBase64ImageUrl(
          document.getElementById('imagepreview')
        );
        let a = document.createElement('a');
        let blob = this.base64ToBlob(url);
        let evt = document.createEvent('HTMLEvents');
        evt.initEvent('click', true, true);
        let name = this.currentUrl.replace(/^.*[\\\/]/, '');
        a.download = name.substring(name.indexOf('_') + 1);
        a.href = URL.createObjectURL(blob);
        a.click();
      }
    }
  };
</script>

<style scoped>
  .viewer-container {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .album-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  .image-preview_prev {
    cursor: pointer;
    left: 10px;
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
  }
  .image-preview_next {
    cursor: pointer;
    right: 10px;
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
  }
</style>
